import { categoryInit } from 'redux/reducers/init';
import {
  requestCategoryList,
  requestCategoryListFailure,
  requestCategoryListSuccess,
} from 'redux/actions/actions';

import { createReducer } from '@reduxjs/toolkit';

const category = createReducer(categoryInit, {
  [requestCategoryList.type]: (state, action) => {
    state.isLoading = true;
  },
  [requestCategoryListSuccess.type]: (state, action) => {
    const { categoryList } = action.payload;
    state.isInit = true;
    state.isLoading = false;
    state.categoryList = categoryList;
  },
  [requestCategoryListFailure.type]: (state, action) => {
    state.isInit = false;
    state.isLoading = false;
    state.categoryList = [];
  },
});

export default category;
